import { useState } from "react";
import AppBreadcrumbs from "components/common/AppBreadcrumbs";
import TransactionsTabsPanel from "pages/transaction/TransactionsTabsPanel";
import { TRANSACTION_TABS } from "pages/transaction/transactionTabs";

export default function TransactionsPage() {
  const [activeTabId, setActiveTabId] = useState(TRANSACTION_TABS[0].id);

  return (
    <>
      <AppBreadcrumbs items={[{ label: "Transactions", path: "/transactions" }]} />
      <TransactionsTabsPanel activeTabId={activeTabId} onTabChange={setActiveTabId} />
    </>
  );
}
